"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var DmRoutePoint=function(){};exports.DmRoutePoint=DmRoutePoint;